import { Timestamp } from "firebase/firestore";
import { getCurrentTimeStamp } from "../utility/datehelper";

export interface Product {
    id:string;
    categoryId:string;
    name: string;
    title: string;
    brand:string;
    description?: string;
    descriptionList: string[];
    features:object;
    stock:number;
    mainImageUrl:string;
    productImages:string[];
    sizes:string[];
    colors:string[];
    productBasePrice:number;
    productPrice:number;
    productStrikePrice:number;    
    status:string;    
    actionDate:Timestamp;
    actionBy:string;
}
export interface IProductItem {
    id: string;
    name: string;
    title: string;
    productPrice: number | string;
    productStrikePrice:number | string;
    mainImageUrl: string;
    displayMode:string,
}
export class Product implements IProductItem
{
    constructor(product?:Product)
    {
        if(product)
        {
            Object.assign(this,product);
        }
    }
    id:string = "";
    categoryId:string = "";
    name: string = "";
    title: string = "";
    brand:string = "";
    description?: string = "";
    descriptionList: string[]=[];
    features:object={};
    stock:number=1;
    mainImageUrl:string = "";
    productImages:string[]=[];
    sizes:string[] = [];
    colors:string[] = [];
    productBasePrice:number=0;
    productPrice:number=0;
    productStrikePrice:number=0;    
    status:string = "";    
    actionDate:Timestamp= getCurrentTimeStamp();
    actionBy:string="SuperAdmin";
    displayMode:string = "photo";
}